jQuery(function($) {
	// 記事詳細ページ 目次アコーディオン
	$('.toc-accordion-on .wpco-wrapper').after('<div class="mizutell-accordion-button-wrap"><span class="mizutell-accordion-button"><span class="mizutell-accordion-button__icon"><i class="fa-solid fa-chevron-up"></i></span></span></div>');

	$('.mizutell-accordion-button').on('click', function() {
		$(this).parent().prev('.wpco-wrapper').toggleClass('is-active');
		$(this).toggleClass('is-active');
	});
});

// トップページ おすすめ記事 スライドショー
const mediaQueryList = window.matchMedia("(max-width: 1023px)");
let pickup_news__slide = null;
const initPickUpNewsSwiper = () => {
	if (mediaQueryList.matches) {
		pickup_news__slide = new Swiper(".pickup-news__slide", {
			navigation: {
				nextEl: ".pickup-news__swiper-button-next",
				prevEl: ".pickup-news__swiper-button-prev",
			},
			loop: true,
			speed: 500,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false
			},
			slidesPerView: 2,
			breakpoints: {
				782: {
					slidesPerView: 3,
				},
			},
		});
	} else {
		if (pickup_news__slide) {
			pickup_news__slide.destroy(false, true);
		}
	}
};

mediaQueryList.addEventListener('change', initPickUpNewsSwiper);
initPickUpNewsSwiper();